webpackJsonp([1],Array(23).concat([
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(121),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b51fbef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);


/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue, options) {
		Vue.backends = {
			get: function get() {
				return __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem('backends').then(function (value) {

					if (value) {
						return value;
					}

					return Vue.http.get(options.url).then(function (response) {
						__WEBPACK_IMPORTED_MODULE_0_localforage___default.a.setItem('backends', response.data);
						return response.data;
					});
				});
			},
			selected: function selected(item) {
				if (!item) {
					return __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem('selectedBackend');
				}

				Vue.http.options.root = item.url;
				return __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.setItem('selectedBackend', item);
			}
		};

		Vue.prototype.$backends = {
			get: Vue.backends.get,
			selected: Vue.backends.selected
		};
	}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selection__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_battle__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_battle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_battle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_end__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_api_router__ = __webpack_require__(50);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    alias: '*',
    name: 'selection',
    component: __WEBPACK_IMPORTED_MODULE_2__components_selection___default.a
  }, {
    path: '/end',
    name: 'end',
    component: __WEBPACK_IMPORTED_MODULE_4__components_end___default.a,
    params: {
      player: {},
      against: {},
      playerWins: null
    }
  }, {
    path: '/battle/:pokemon',
    name: 'battle',
    component: __WEBPACK_IMPORTED_MODULE_3__components_battle___default.a
  }]
});

router.beforeEach(__WEBPACK_IMPORTED_MODULE_5__components_api_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(122),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {

  if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.root || ['noapi', 'error'].indexOf(to.name) > -1) {
    next();
    return;
  }

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_vue__["default"].backends.get(), __WEBPACK_IMPORTED_MODULE_1_vue__["default"].backends.selected()]).then(function (values) {

    if (values[0].length == 0) {
      next({ name: 'noapi' });
      return;
    }

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.root = values[1] ? values[1].url : values[0][0].url;
    next();
  }).catch(function (e) {
    next({ name: 'error' });
  });
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'actions',
  props: {
    items: {
      type: Array
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__character__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__character___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__character__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_header__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'battle',
  data: function data() {
    return {
      player: {},
      against: {},
      actions: { player: [], against: [] },
      currentHealth: { player: 0, against: 0 }
    };
  },

  methods: {
    formatData: function formatData(attack) {
      return {
        player: {
          name: this.player.name,
          currentHealth: this.currentHealth.player,
          attack: attack.name
        },
        against: {
          name: this.against.name,
          currentHealth: this.currentHealth.against
        }
      };
    },
    isAlive: function isAlive(health, isPlayer) {
      if (health <= 0) {
        this.$router.push({ name: 'end', params: {
            player: this.player,
            against: this.against,
            playerWins: !isPlayer
          } });
      }
    },
    attack: function attack(_attack) {
      var _this = this;

      this.$http.post('hit', this.formatData(_attack)).then(function (response) {
        response.data.player.attack = _attack.name;

        _this.actions.player.splice(0, 0, response.data.player);
        _this.currentHealth.against = response.data.against.currentHealth;

        _this.isAlive(_this.currentHealth.against, false);

        setTimeout(function () {
          _this.actions.against.splice(0, 0, response.data.against);
          _this.currentHealth.player = response.data.player.currentHealth;

          _this.isAlive(_this.currentHealth.player, true);
        }, 2000);
      }, function (response) {});
    },
    start: function start() {
      this.currentHealth.player = this.player.health;
      this.actions.player = [];
      this.currentHealth.against = this.against.health;
      this.actions.against = [];
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.post('select', { name: this.$route.params.pokemon }).then(function (response) {
      _this2.player = response.data.player;
      _this2.against = response.data.against;
      _this2.start();
    }, function (response) {});
  },

  components: { character: __WEBPACK_IMPORTED_MODULE_0__character___default.a, actions: __WEBPACK_IMPORTED_MODULE_1__actions___default.a, vueHeader: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'character',
  data: function data() {
    return {
      apiUrl: this.$http.options.root,
      isAttacking: false
    };
  },

  computed: {
    lifeStatus: function lifeStatus() {
      var result = (100 * this.currentHealth / this.player.health).toFixed(0);
      return isNaN(result) ? 100 : result;
    },
    condition: function condition() {
      if (this.lifeStatus < 26) {
        return { class: 'danger', title: this.player.name + ' is about to die' };
      }

      if (this.lifeStatus < 51) {
        return { class: 'warning', title: this.player.name + " doesn't have too much health left" };
      }

      return { class: '', title: this.player.name + " is in a good condition" };
    }
  },
  methods: {
    hit: function hit(attack) {
      var _this = this;

      if (this.isCpu || this.isAttacking) {
        return;
      }

      this.isAttacking = true;
      this.$emit('attack', attack);
      setTimeout(function () {
        _this.isAttacking = false;
      }, 3000);
    }
  },
  props: {
    player: {
      type: Object,
      required: true
    },
    isCpu: {
      type: Boolean,
      default: false
    },
    currentHealth: {
      type: Number,
      default: 0
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'end',
  data: function data() {
    return {
      values: this.$route.params,
      apiUrl: this.$http.options.root
    };
  },

  computed: {
    message: function message() {
      return this.values.playerWins ? 'Congratulations you won!' : 'You lose!';
    },
    winner: function winner() {
      if (this.values.playerWins) {
        return { name: this.values.player.name, avatar: this.values.player.avatar };
      }

      return { name: this.values.against.name, avatar: this.values.against.avatar };
    },
    loser: function loser() {
      return this.values.playerWins ? this.values.against.name : this.values.player.name;
    }
  },
  created: function created() {
    if (this.values.playerWins == undefined) {
      this.$router.push({ name: 'selection' });
      return;
    }
  },

  components: { vueHeader: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__help__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__help__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  data: function data() {
    return {
      apis: [],
      selectedApi: null
    };
  },

  methods: {
    help: function help() {
      this.$refs.help.open();
    },
    changeApi: function changeApi() {
      this.$backends.selected(this.selectedApi);
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$backends.get(), this.$backends.selected()]).then(function (values) {
      _this.apis = values[0];
      if (!values[0].length) {
        return;
      }

      _this.selectedApi = values[1] ? values[1] : values[0][0];
    });
  },

  components: { help: __WEBPACK_IMPORTED_MODULE_1__help___default.a }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    name: "help",
    methods: {
        open: function open() {
            jQuery('#modal').modal('show');
        }
    }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selection',
  methods: {
    select: function select(player) {
      this.$router.push({ name: 'battle', params: { pokemon: player.name } });
    }
  },
  data: function data() {
    return {
      apiUrl: this.$http.options.root,
      players: []
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get('all').then(function (response) {
      _this.players = response.data;
    }, function (response) {});
  },

  components: { vueHeader: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_api__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_auto_progress__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_auto_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_auto_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(48);










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__components_api__["a" /* default */], { url: 'https://vanderleisilva.github.io/pokemon-battle/backend-api.json' });

window.jQuery = __webpack_require__(45);
__webpack_require__(42);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<div><App/><auto-progress/></div>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a, autoProgress: __WEBPACK_IMPORTED_MODULE_6_vue_auto_progress___default.a }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(126),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4209470",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0213a4f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7441f4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0523fde2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e9538c80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumbnail",
    class: _vm.condition.class,
    attrs: {
      "title": _vm.condition.title
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.isAttacking) ? _c('div', {
    staticClass: "attacking bg-danger",
    attrs: {
      "title": _vm.player.name + ' is attacking'
    }
  }, [_vm._v("\n\t\t\tOn attack! \n\t\t\t"), _c('i', {
    staticClass: "fa fa-bolt",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('div', {
    staticClass: "progress",
    attrs: {
      "title": "Life"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ('width: ' + _vm.lifeStatus + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.lifeStatus,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n\t\t    " + _vm._s(_vm.lifeStatus) + "%\n\t\t  ")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Health: " + _vm._s(_vm.player.health))]), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agility: " + _vm._s(_vm.player.agility))]), _vm._v(" "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Defense: " + _vm._s(_vm.player.defense))])])]), _vm._v(" "), _c('div', {
    staticClass: "container-image"
  }, [(_vm.player.avatar) ? _c('img', {
    attrs: {
      "src": _vm.apiUrl + _vm.player.avatar,
      "alt": _vm.player.name
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [(_vm.player.attacks) ? _c('ul', {
    staticClass: "list-group",
    attrs: {
      "title": "Attacks"
    }
  }, _vm._l((_vm.player.attacks), function(attack) {
    return _c('li', {
      staticClass: "list-group-item",
      class: {
        'attack-click': !_vm.isCpu && !_vm.isAttacking
      },
      attrs: {
        "title": !_vm.isCpu && !_vm.isAttacking ? 'Click to trigger attack' : ''
      },
      on: {
        "click": function($event) {
          _vm.hit(attack)
        }
      }
    }, [_c('span', {
      staticClass: "attack-name"
    }, [_vm._v(_vm._s(attack.name))]), _vm._v(" "), _c('span', {
      staticClass: "label label-default",
      attrs: {
        "title": "Type"
      }
    }, [_vm._v(_vm._s(attack.type))]), _vm._v(" "), _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Power: " + _vm._s(attack.power))]), _vm._v(" "), _c('span', {
      staticClass: "label label-warning",
      attrs: {
        "title": "Accuracy"
      }
    }, [_vm._v("Acc.: " + _vm._s(attack.accuracy))])])
  })) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-header', [_c('small', [_vm._v("End of battle")])]), _vm._v(" "), _c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', [(_vm.values.playerWins) ? _c('i', {
    staticClass: "fa fa-trophy",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.values.playerWins) ? _c('i', {
    staticClass: "fa fa-frown-o",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(_vm.message) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "pull-left",
    attrs: {
      "src": _vm.apiUrl + _vm.winner.avatar,
      "alt": _vm.winner.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 padding-top"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.winner.name))]), _vm._v(" is the winner!!! "), _c('b', [_vm._v(_vm._s(_vm.loser))]), _vm._v(" had no chances and was destroyed!")]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "to": {
        name: 'selection'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Try again\n\t\t\t\t\t")])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_c('router-link', {
    staticClass: "hidden-xs",
    attrs: {
      "to": {
        name: 'selection'
      }
    }
  }, [_vm._v("\n\t\t\tPokémon Battle\n\t\t")]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [(_vm.apis.length) ? _c('div', {
    staticClass: "form-group hidden-xs"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApi),
      expression: "selectedApi"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Backend Api"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApi = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeApi]
    }
  }, _vm._l((_vm.apis), function(api) {
    return _c('option', {
      domProps: {
        "value": api
      }
    }, [_vm._v(_vm._s(api.name))])
  }))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "btn btn-default fa fa-info-circle help",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.help
    }
  })]), _vm._v(" "), _c('help', {
    ref: "help"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Fechar"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("About Pokémon Battle")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("This game considers the traditional Pokémon table of advantages/disadvantages. "), _c('br'), _vm._v("\n                For instance, Electric attacks causes double damage over Water Pokémons but only half\n                on a Grass type. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                Also, each attack has a probability to fail (miss the target) or cause critical damage (double damage).\n                Basically, this calculation considers attacker's strength, target's defense, a multiplier regarding \n                types and a random value.\n                ")]), _vm._v(" "), _c('p', [_vm._v("Have fun!")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Got it!\n                ")])])])])])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-header', [_c('small', [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" X "), _c('small', [_vm._v(_vm._s(_vm.against.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('character', {
    ref: "player",
    attrs: {
      "current-health": _vm.currentHealth.player,
      "player": _vm.player
    },
    on: {
      "attack": _vm.attack
    }
  }), _vm._v(" "), _c('actions', {
    attrs: {
      "items": _vm.actions.player
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('character', {
    ref: "against",
    attrs: {
      "is-cpu": true,
      "current-health": _vm.currentHealth.against,
      "player": _vm.against
    }
  }), _vm._v(" "), _c('actions', {
    attrs: {
      "items": _vm.actions.against
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-header', [_c('small', [_vm._v("select your Pokémon")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.players), function(player) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_c('div', {
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.select(player)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_c('h3', [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Health: " + _vm._s(player.health))]), _vm._v(" "), _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Agility: " + _vm._s(player.agility))]), _vm._v(" "), _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Defense: " + _vm._s(player.defense))])])]), _vm._v(" "), _c('div', {
      staticClass: "container-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.apiUrl + player.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [(player.attacks) ? _c('ul', {
      staticClass: "list-group",
      attrs: {
        "title": "Attacks"
      }
    }, _vm._l((player.attacks), function(attack) {
      return _c('li', {
        staticClass: "list-group-item"
      }, [_c('span', {
        staticClass: "attack-name"
      }, [_vm._v(_vm._s(attack.name) + ":")]), _vm._v(" "), _c('span', {
        staticClass: "label label-default",
        attrs: {
          "title": "Type"
        }
      }, [_vm._v(_vm._s(attack.type))]), _vm._v(" "), _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("Power: " + _vm._s(attack.power))]), _vm._v(" "), _c('span', {
        staticClass: "label label-warning",
        attrs: {
          "title": "Accuracy"
        }
      }, [_vm._v("Acc.: " + _vm._s(attack.accuracy))])])
    })) : _vm._e()])])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.items), function(item) {
    return _c('p', [_vm._v(" \n    \t" + _vm._s(item.name) + " attacked with "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(item.attack))]), _c('br'), _vm._v("\n    \tdamage caused: "), _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(item.damage))]), _vm._v(" "), _c('br'), _c('b', [_vm._v(_vm._s(item.desc ? item.desc : ''))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[58]);


// WEBPACK FOOTER //
// static/js/app.0a0138fdec3ddfb10357.js